import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  motion,
  useMotionValue,
  useSpring,
  useTransform
} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

function ServiceCard({ service, index }) {
  const [hovered, setHovered] = useState(false);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useSpring(useTransform(y, [-0.5, 0.5], [7, -7]));
  const rotateY = useSpring(useTransform(x, [-0.5, 0.5], [-7, 7]));

  const handleMove = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    x.set((event.clientX - bounds.left) / bounds.width - 0.5);
    y.set((event.clientY - bounds.top) / bounds.height - 0.5);
  };

  const reset = () => {
    setHovered(false);
    x.set(0);
    y.set(0);
  };

  return (
    <motion.article
      className="service-card interactive-card"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay: index * 0.06 }}
      style={{ rotateX, rotateY, transformPerspective: 1000 }}
      onPointerMove={handleMove}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={reset}
    >
      <Link
        to={`/services/${service.slug}`}
        aria-label={`Learn more about ${service.title}`}
      >
        <motion.img
          src={service.image}
          alt=""
          aria-hidden="true"
          animate={{ scale: hovered ? 1.1 : 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="service-overlay">
          <span className="card-number" aria-hidden="true">
            {service.number}
          </span>
          <div>
            <SafeIcon name={service.icon} aria-hidden="true" focusable="false" />
            <h3>{service.title}</h3>
            <p>{service.short}</p>
          </div>
          <span className="round-link" aria-hidden="true">
            <SafeIcon name="ArrowUpRight" focusable="false" />
          </span>
        </div>
        <div className="card-glow" aria-hidden="true" />
      </Link>
    </motion.article>
  );
}

export default ServiceCard;